/**
 * Fire-and-forget analytics helper for customer web surfaces.
 * Every call is non-blocking — errors are swallowed after a dev-mode
 * console.warn so UI interactions never stall on network hiccups.
 */
import { API_BASE, TOKEN_KEY } from "@/lib/api";

const SESSION_KEY = "offernest_session_id";

function getSessionId() {
    try {
        let id = localStorage.getItem(SESSION_KEY);
        if (!id) {
            id = (crypto?.randomUUID?.() || `sess-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`);
            localStorage.setItem(SESSION_KEY, id);
        }
        return id;
    } catch { return null; }
}

/**
 * @param event_type — must be in the server's ALLOWED_EVENTS whitelist.
 * @param metadata — free-form dict (session_id auto-injected).
 * @param target — optional `{type, id}` shortcut for target_type / target_id.
 */
export function trackEvent(event_type, metadata = {}, target = {}) {
    try {
        const token = localStorage.getItem(TOKEN_KEY);
        const body = {
            event_type,
            target_type: target.type || null,
            target_id: target.id || null,
            metadata: { ...metadata, session_id: getSessionId() },
        };
        fetch(`${API_BASE}/events`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                ...(token ? { Authorization: `Bearer ${token}` } : {}),
            },
            body: JSON.stringify(body),
            keepalive: true,
        }).catch((e) => {
            if (process.env.NODE_ENV !== "production") console.warn("[analytics] failed:", e?.message);
        });
    } catch (e) {
        if (process.env.NODE_ENV !== "production") console.warn("[analytics] sync error:", e?.message);
    }
}

export default trackEvent;
